import { createContext } from "react";
import { useGetLatestPrescriptionQuery } from "src/api/services/prescriptionsApi";
import { PrescriptionWithProduct } from "src/api/types";

export const LatestPrescriptionContext = createContext<
  PrescriptionWithProduct | undefined
>(undefined);

interface Props {
  children: React.ReactNode;
}

const LatestPrescriptionProvider = ({ children }: Props) => {
  const { data, isLoading } = useGetLatestPrescriptionQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  if (isLoading === true) {
    return;
  }

  return (
    <LatestPrescriptionContext.Provider value={data}>
      {children}
    </LatestPrescriptionContext.Provider>
  );
};

export default LatestPrescriptionProvider;
